<div class="loading-bg">
  <div class="loading-logo">
    <img
      [src]="logoService.smallLogoPath"
      alt="Logo"
      width="200" />
  </div>
  <div class="loading">
    <div class="effect-1 effects"></div>
    <div class="effect-2 effects"></div>
    <div class="effect-3 effects"></div>
  </div>
</div>
